import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from '../../Environment';
import {
  AcceptEstimateMutation,
  AcceptEstimateMutation$variables,
} from './__generated__/AcceptEstimateMutation.graphql';

const mutation = graphql`
  mutation AcceptEstimateMutation($input: AcceptEstimateInput!) {
    acceptEstimate(input: $input) {
      estimate {
        id
        status
      }
    }
  }
`;

const commit = (webToken, callback) => {
  const variables: AcceptEstimateMutation$variables = {
    input: {
      webToken: webToken,
    },
  };

  commitMutation<AcceptEstimateMutation>(environment, {
    mutation,
    variables,
    onCompleted: (response) => {
      const estimate = response.acceptEstimate?.estimate;
      callback(estimate);
    },
    onError: (err) => console.error(err),
  });
};

export default commit;
